<script>
    import axios from 'axios';
    import MultipleSelector from '@/components/Form/MultipleSelector.vue'

    export default {
        name: 'brand-selector',
        extends: MultipleSelector,
        methods: {
            buildOptions: function (brands) {
                let options = [];
                for (let key in brands) {
                    let option = {};
                    option['id'] = brands[key]['id'];
                    option['name'] = brands[key]['name'] + ` (${brands[key]['id']})`;
                    options.push(option);
                }
                return options;
            },
            initBrands() {
                axios
                    .get('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_web_json/Brands/list')
                    .then(response => {
                        if (response.data.result) {
                            this.options = this.buildOptions(response.data.data);
                        } else {
                            this.emitError();
                        }
                    }).catch(error => {
                    this.emitError();
                })
            },
            emitError() {
                this.$emit('error', "Se ha producido un error al consultar las marcas.");
            }
        },
        created() {
            this.initBrands();
        }
    }
</script>